import { __assign } from "tslib";
var commonCardStyles = function (props) {
    var theme = props.theme;
    var effects = theme.effects;
    return {
        border: 'none',
        boxShadow: effects.elevation16,
        borderRadius: effects.roundedCorner2,
        selectors: {
            '.ms-Callout-main': { borderRadius: effects.roundedCorner2 },
        },
    };
};
export var ExpandingCardStyles = function (props) {
    return {
        root: __assign(__assign({}, commonCardStyles(props)), { width: 320 }),
        expandedCard: {
            selectors: {
                ':before': {
                    width: 272,
                },
            },
        },
    };
};
export var PlainCardStyles = function (props) {
    return {
        root: __assign({}, commonCardStyles(props)),
    };
};
//# sourceMappingURL=HoverCard.styles.js.map